import { Cache } from '../cache-classes/cache.class';
import { ControllerContextOptions } from './types';
import { Logger } from '../logger-classes';

export class ControllerContext {
	readonly logger: Logger;
	readonly cache: Cache;

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	constructor (options: Partial<ControllerContextOptions>) {
		this.logger = new Logger({});
		// Enable cache logging for initial review - set to false to disable
		this.cache = new Cache({ enableLogging: false });
	}
}
